<template>
    <div class="vuetify-wrapper">
        <div class="v-application v-application--is-ltr">
            <v-card>
                <v-card outlined elevation="0" class="rounded-lg mx-5 mt-3 v-application">
                    <v-card-title>
                        <div class="d-flex flex-wrap align-baseline">
                            <span class="ml-5 body-1" v-if="phone">
                                <span class="h4">Telefon: </span>
                                <a :href="`tel:${phone}`" @click="addCallHistory">{{ phone }}</a>
                            </span>
                            <span class="ml-4" v-if="mobile">
                                <span class="h4">Mobile: </span>
                                <a :href="`tel:${mobile}`" @click="addCallHistory">{{ mobile }}</a>
                            </span>
                            <span class="ml-10">
                                <v-btn
                                    @click="isConfirmationDialogOpen = true"
                                    small
                                    outlined
                                    color="primary"
                                    class="capture-call-btn"
                                >
                                    <v-icon small class="mr-2">mdi-phone</v-icon>
                                    <span>Call Erfassen</span>
                                </v-btn>
                            </span>
                        </div>
                    </v-card-title>
                </v-card>
                <ConfirmationDialog
                    v-model="isConfirmationDialogOpen"
                    @save="addCallHistory"
                    message="Call Erfassen?"
                />

                <v-data-table
                    :headers="historyHeaders"
                    :items="callHistory"
                    class="elevation-1 v-application--is-ltr"
                    :items-per-page="25"
                    no-data-text="Keine Apotheken in dieser Kategorie"
                    :options.sync="tableOptions"
                    :loading="isLoading"
                    loading-text="Wird geladen..."
                    @update:options="onOptionsChange"
                    disable-filtering
                    :footer-props="{
                        'items-per-page-options': [25, 50, 100],
                        'show-first-last-page': true,
                        'items-per-page-text': 'Zeilen pro Seite'
                    }"
                >
                    <template v-slot:item="{ item }">
                        <tr :data-call-id="item.call_id">
                            <td>
                                <div>
                                    <a :href="`/pharmacists/${item.user_id}`" target="_blank" class="text-decoration-none">
                                        {{ item.caller_user.firstname }} {{ item.caller_user.lastname }}
                                    </a>
                                    <div>
                                        <small>{{ item.caller_user.email }}</small>
                                    </div>
                                </div>
                            </td>
                            <td>{{ formatDate(item.date) }}</td>
                            <td>
                                <v-simple-checkbox
                                    :value="item.is_successful"
                                    @click="updateCallHistory(item)"
                                />
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </div>
    </div>
</template>


<script>
import axios from 'axios';
import _ from 'lodash';
import { mapMutations } from 'vuex';
import ConfirmationDialog from '../appointments/ConfirmationDialog.vue';


export default {
    components: {
        ConfirmationDialog
    },
    props: {
        pharmacyId: String,
        phone: String,
        mobile: String,
    },
    data() {
        return {
            callHistory: [],
            callHistoryCount: 0,
            tableOptions: {},
            isLoading: false,
            historyHeaders: [
                { text: 'Agent', value: 'user_id' },
                { text: 'Datum', value: 'date' },
                { text: 'Erfolgreich?', value: 'is_successful', width: '110px', searchable: false },
            ],
            isConfirmationDialogOpen: false
        }
    },
    methods: {
        formatDate(unformattedDate) {
            let date = unformattedDate;
            if (!date.includes('+')) date += 'Z'; // for date strings without Z
            return moment(date).format('DD-MM-YYYY, HH:mm');
        },
        async getCallHistory(page = 1, sortBy = "date", sortAsc = -1, itemsPerPage = 25) {
            try {
                this.isLoading = true;
                const response = await axios.get(`/api/pharmacies/${this.pharmacyId}/call_history`, {
                params: {
                        page: page,
                        sort_by: sortBy,
                        sort_asc: sortAsc,
                        page_size: itemsPerPage,
                    }
                });
                this.callHistory = response.data?.data || [];
                this.callHistoryCount = response.data?.total || 0;
            } catch (error) {
                this.alertError();
            } finally {
                this.isLoading = false
            }
        },
        async addCallHistory() {
            try {
                const response = await axios.post(`/api/pharmacies/${this.pharmacyId}/call_history`);
                if (response.status != 200) {
                    throw new Error(response.statusText);
                }
                this.alertSuccess("Call gespeichert");
                await this.getCallHistory();
            }
            catch (error) {
                this.alertError();
            }
        },

        async updateCallHistory(call) {
            try {
                const response = await axios.put(`/api/pharmacies/${this.pharmacyId}/call_history`, {
                    ...call,
                    is_successful: !call.is_successful,
                });
                if (response.status != 200) throw new Error(response.statusText);

                this.alertSuccess("erfolgreich gespeichert");
                this.callHistory.find(({ call_id }) => call_id === call.call_id).is_successful = !call.is_successful;
            }
            catch {
                this.alertError();
            }
        },

        onOptionsChange(options) {
            const page = options.page;
            const sortBy = options.sortBy[0];
            const sortAsc = options.sortDesc[0] ? -1 : 1;
            const itemsPerPage = options.itemsPerPage;
            this.getCallHistory(page, sortBy, sortAsc, itemsPerPage);
        },
        ...mapMutations({
            alertError: "alert/error",
            alertSuccess: "alert/success",
        }),
    }
}
</script>

<style scoped>
.vuetify-wrapper .v-application {
  display: block;
}
</style>
